import AppIcon from '@assets/icons/smartphone.svg';
import EmailIcon from '@assets/icons/email-small.svg';
import MergedIcon from '@assets/icons/merged.svg';
import React from 'react';
import SmsIcon from '@assets/icons/sms.svg';
import VoicemailIcon from '@assets/icons/voicemail.svg';
import { createStyles } from '@/contexts/theme-context';
import { OrderInboundSource } from '@/enums';
import { StyleProp, View, ViewStyle } from 'react-native';
import { SvgProps } from 'react-native-svg';

export interface Props {
  iconStyle?: StyleProp<ViewStyle>;
  isDisabled?: boolean;
  isMerged?: boolean;
  source?: OrderInboundSource;
}

const SourceIcons: Record<OrderInboundSource, React.ComponentType<SvgProps>> = {
  APP: AppIcon,
  EMAIL: EmailIcon,
  SMS: SmsIcon,
  VOICEMAIL: VoicemailIcon,
};

export const OrderSourceIcon: React.FC<Props> = ({
  source,
  iconStyle,
  isDisabled,
  isMerged,
}) => {
  const [styles, theme] = useStyles();
  const SourceIcon = source ? SourceIcons[source] : View;
  const Icon = isMerged ? MergedIcon : SourceIcon;
  return (
    <View style={[styles.icon, iconStyle]}>
      <Icon
        fill={
          isDisabled
            ? theme.sk.color.icon.disabled
            : theme.sk.color.icon.primary
        }
      />
    </View>
  );
};

export const SOURCE_ICON_SIZE = 40;

const useStyles = createStyles((theme) => ({
  icon: {
    alignItems: 'center',
    backgroundColor: theme.sk.color.bg.secondary.default,
    borderRadius: SOURCE_ICON_SIZE,
    height: SOURCE_ICON_SIZE,
    justifyContent: 'center',
    width: SOURCE_ICON_SIZE,
  },
}));
